(function () {
  function toHalfWidth(value) {
    return value
      .replace(/[！-～]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
      })
      .replace(/　/g, ' ');
  }

  function convertInput(el) {
    var converted = toHalfWidth(el.value);
    if (converted === el.value) return;

    var start = el.selectionStart;
    var end = el.selectionEnd;
    el.value = converted;

    if (start !== null && end !== null && typeof el.setSelectionRange === 'function') {
      el.setSelectionRange(start, end);
    }
  }

  var selector = 'input[type="text"]';

  document.addEventListener('compositionstart', function (e) {
    if (e.target.matches(selector)) {
      e.target.dataset.composing = 'true';
    }
  });

  document.addEventListener('compositionend', function (e) {
    if (e.target.matches(selector)) {
      e.target.dataset.composing = 'false';
      convertInput(e.target);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches(selector) && e.target.dataset.composing !== 'true') {
      convertInput(e.target);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches(selector)) {
      convertInput(e.target);
    }
  });
})();